import { getCurrentProfileSelect } from '@gymaholic/packages'
import { createSelector } from 'reselect'

const existsProfileSelect = createSelector(
  getCurrentProfileSelect,
  (profile) => !!profile
)

export default existsProfileSelect
